import { QUOTE_CALCULATED } from 'utils/constants'

export default (state = {}, action) => {
  switch (action.type) {
    case QUOTE_CALCULATED:
      const { quote } = action.data;
      return { ...state, [quote.uuid]: quote };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/quotes.js